import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';

export class LinkTarget extends AStringEnum
{
    public static SELF = new AString('Same Window');
    public static BLANK = new AString('New Window');

    public static types:Array<AString> = [
        LinkTarget.SELF,
        LinkTarget.BLANK
    ];

    public static toTargetAttributeString(linkTarget:LinkTarget):string
    {
        if( LinkTarget.isBlank(linkTarget) )
            return '_blank';
        if( LinkTarget.isSelf(linkTarget) )
            return '_self';

        return '';
    }

    public constructor(value:AString)
    {
        super(value, LinkTarget.types);
    }

    public static self():LinkTarget
    {
        return new LinkTarget(LinkTarget.SELF);
    }

    public static blank():LinkTarget
    {
        return new LinkTarget(LinkTarget.BLANK);
    }

    public static isSelf(linkTarget:LinkTarget):boolean
    {
        return linkTarget && LinkTarget.SELF.isEqualTo(linkTarget.value);
    }

    public static isBlank(linkTarget:LinkTarget):boolean
    {
        return linkTarget && LinkTarget.BLANK.isEqualTo(linkTarget.value);
    }
}
